import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=961eb19e&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=js&"
export * from "./AdminLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=961eb19e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961eb19e",
  null
  
)

export default component.exports